export var CompanyType;
(function (CompanyType) {
    CompanyType["Accountant"] = "ACCOUNTANT";
    CompanyType["Solicitor"] = "SOLICITOR";
})(CompanyType || (CompanyType = {}));
export var PersonType;
(function (PersonType) {
    PersonType["Spouse"] = "SPOUSE";
})(PersonType || (PersonType = {}));
export var VisitContactType;
(function (VisitContactType) {
    VisitContactType["LoanParty"] = "LOAN_PARTY";
    VisitContactType["Tenant"] = "TENANT";
    VisitContactType["RealEstateAgent"] = "REAL_ESTATE_AGENT";
})(VisitContactType || (VisitContactType = {}));
export var SubstantialBenefitType;
(function (SubstantialBenefitType) {
    SubstantialBenefitType["SubstantialBenefit"] = "SUBSTANTIAL_BENEFIT";
    SubstantialBenefitType["NoSubstantialBenefitAndProceed"] = "NO_SUBSTANTIAL_BENEFIT_AND_PROCEED";
    SubstantialBenefitType["NoSubstantialBenefit"] = "NO_SUBSTANTIAL_BENEFIT";
})(SubstantialBenefitType || (SubstantialBenefitType = {}));
export var CompanyApplicantRelatedPartyType;
(function (CompanyApplicantRelatedPartyType) {
    CompanyApplicantRelatedPartyType["CompanyContact"] = "COMPANY_CONTACT";
    CompanyApplicantRelatedPartyType["CompanyBeneficialOwner"] = "COMPANY_BENEFICIAL_OWNER";
    CompanyApplicantRelatedPartyType["Director"] = "DIRECTOR";
})(CompanyApplicantRelatedPartyType || (CompanyApplicantRelatedPartyType = {}));
export var TrustApplicantRelatedPartyType;
(function (TrustApplicantRelatedPartyType) {
    TrustApplicantRelatedPartyType["TrustSettlor"] = "TRUST_SETTLOR";
    TrustApplicantRelatedPartyType["TrustBeneficialOwner"] = "TRUST_BENEFICIAL_OWNER";
    TrustApplicantRelatedPartyType["TrustBeneficiary"] = "TRUST_BENEFICIARY";
    TrustApplicantRelatedPartyType["Trustee"] = "TRUSTEE";
})(TrustApplicantRelatedPartyType || (TrustApplicantRelatedPartyType = {}));
//# sourceMappingURL=RelatedParty.js.map